import { ICreateYapePromotionRequest } from 'core/model/interfaces/yape/yape.interface';
import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { handleErrorMessage, showNotificationError } from 'shared/utils/errors.utils';
import { notificationService } from 'shared/utils/notification.utils';
import { SLICE_NAMESPACE } from '../constants';
import { IYapeState } from '../types';

export const createYapePromotion = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/createYapePromotion`,
  async (data: ICreateYapePromotionRequest) => {
    try {
      await apiService.yape.createYapePromotion(data);
      notificationService.global.success('La promoción ha sido creada correctamente.');
    } catch (e) {
      const errorMessage = handleErrorMessage(e, 'Ocurrió un error al crear la promoción.');
      showNotificationError(errorMessage);
      throw e;
    }
  },
);

export const createYapePromotionReducer: TSliceExtraReducer<IYapeState> = builder =>
  builder
    .addCase(createYapePromotion.pending, state => {
      state.promo.form.loading = true;
      state.promo.form.success = false;
    })
    .addCase(createYapePromotion.rejected, state => {
      state.promo.form.loading = false;
      state.promo.form.success = false;
    })
    .addCase(createYapePromotion.fulfilled, state => {
      state.promo.form.loading = false;
      state.promo.form.success = true;
    });
